<template>

    <div id="right-panel" class="right-panel fContainer">

        <SellHeader></SellHeader>


        <div class="content mt-3 fColumn">
            <div class="animated fadeIn fColumn">
                <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
                <!--<form action="/" method="post" id="form" class="userForm ajaxForm     fColumn">-->
                    <div class="card     fColumn ">
                        <div class="card-header">
                            <strong>{{$t('businesspartners.title')}}
                                <div class="float-right">
                                    <router-link :to="{ path: '/businesspartner'}" class="btn btn-primary btn-smX"><i class="fa fa-link"></i> {{$t('businesspartner.new')}}</router-link>
                                </div>
                            </strong>
                        </div>
                            <div class="card-body card-block fColumn fColumn">
                                <div class="fContent">
                                    <TableDatatableJs :head="head" :data="data"/>

                                </div>
                            </div>
                    </div>
                <!--</form>-->
            </div><!-- .animated -->
        </div><!-- .content -->
    </div>

</template>

<script>
    // @ is an alias to /src
    import TableDatatableJs from '@/components/TableDatatableJs.vue';


    import LngChooser from '@/components/LngChooser.vue';
    import AlertInPage from '@/components/AlertInPage.vue';
    import Helper from '@/helper/Helper';
    import SellHeader from "../components/SellHeader";
    import InputText from '@/components/InputText.vue';
    import i18n from '@/i18n';
//    import SyncHandler from '@/sync/syncHandler';
    import Api from '@/api/Api';


    export default {
        name: 'BusinessPartners',
        data() {
            const modul = this;
            return {
                hasKeyboard: "false",
                disabled: "false",
                readonly: "false",

                Helper: Helper
                ,

                businesspartner: {
                    id: null,
                    businesspartnername: "",
                    taxnumber: "",
                    taxnumbercountrygroup: "",
                    taxnumberother: "",
                    registrationnumber: "",
                    bank_account: "",
                    dt: null,
                    zip: "",
                    public_space: "",
                    nature_of_public_space: "",
                    house_number: "",
                    building: "",
                    staircase: "",
                    floor: "",
                    door: "",
                    county: "",
                    city: "",
                    country: "",
                    phone_def: "",
                    email_def: "",
                    deleted: 0,
                },
                data: [],
                head: [
                    {
                        key: "id",
                        title: "",
                        linkclass: "text-nowrap",
                        linktext: "global.edit",
                        linkiconclass: "menu-icon fa fa-edit",
                        data: "id",
                        linkfn: function (e, data, type, row, meta) { // data, type, row, meta
                            return modul.modulRowCb(e, data, type, row, meta);
                        }
                    }
                    , {
                        key: "businesspartnername",
                        title: "businesspartner.businesspartnername",
                        searchField:true
                    }
//                    , {
//                        key: "businesspartnernameany",
//                        title: "businesspartner.businesspartnernameany"
//                    }
                    , {
                        key: "taxnumber",
                        title: "businesspartner.taxnumber",
                        searchField:true
                    }
                    , {
                        key: "taxnumbercountrygroup",
                        title: "businesspartner.taxnumbercountrygroup"
                    }
                    , {
                        key: "phone_def",
                        title: "businesspartner.phone_def"
                    }
                    , {
                        key: "email_def",
                        title: "businesspartner.email_def"
                    }


                ]
                , lang: "en"
                , AlertInPage: {
                    type: "", // primary secondary success danger warning info light dark
                    msg: "",
                    delay: 5000,
                }

            };
        },
        watch: {
            'localStorage.lang': function (newLang, oldLang) {
                const modul = this;
                modul.lang = newLang;
            }



        },
        mounted() {
            const modul = this;
            console.log(this.$route.name + " mounded");
            modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
          const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
          if (!Helper.checkRoles(modul.roles, role)) {
                modul.$router.push({name: "login"})
            }
            modul.getElements(function (err, res) {
                if (res && Array.isArray(res)) {
                    modul.data = res;
                }
            })
            modul.$eventBus.$on('globalSetLang', this.globalSetLangEventHandler);
        },
        beforeDestroy() {
            const modul = this;
            modul.$eventBus.$off('globalSetLang');
        },
        methods: {
            modulRowCb: function (e, data, type, row, meta) {
                const modul = this;
                console.log("--" + data);
                modul.$router.push({path: "businesspartner/" + Number(data)})

                return "Print:" + data;
            },
            globalSetLangEventHandler(lang){
                const modul = this;
                modul.lang = lang;
            },
            getElements(cb){
                const modul = this;


              Api.getBusinessPartners({}).then(function (e) {
                if (e && e.result === true) {
                  console.log(e)
                  cb(null,e.data);
                }
              },function (err) {
                console.log(err)
                cb(err,null);
              });
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "businesspartner", "*", "(`deleted` = 0 OR `deleted` = '0')");

            }
        },

        components: {
            LngChooser,
            TableDatatableJs,
            AlertInPage,
            SellHeader,
        },
    };
</script>








